import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  min-height: 400px;
  height: 400px;
  min-width: 400px;
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  border-left: 1px solid;
  border-color: ${({ theme }) => theme.palette.divider};
  padding: 0 8px;
`;

export default Container;
